import { render, staticRenderFns } from "./FondoDiagonal.vue?vue&type=template&id=73c6cfaa&scoped=true"
import script from "./FondoDiagonal.vue?vue&type=script&lang=ts"
export * from "./FondoDiagonal.vue?vue&type=script&lang=ts"
import style0 from "./FondoDiagonal.vue?vue&type=style&index=0&id=73c6cfaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c6cfaa",
  null
  
)

export default component.exports